import React, { useEffect } from 'react';
import { Row } from 'reactstrap';

export const Logout = () => {

    const deleteAllCookies = () => {
        var cookies = document.cookie.split(";");

        for (var i = 0; i < cookies.length; i++) {
            var cookie = cookies[i];
            var eqPos = cookie.indexOf("=");
            var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
            document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
        }
    }

    useEffect(() => {
        deleteAllCookies();
    }, []);

    return (
        <Row style={{ flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
            <span>Ha cerrado sesión exitosamente.</span>
        </Row>
    )
}
